import React from "react";
import DestinoListPageContainer from "./DestinoListPageContainer";

export class DestinoListPage extends React.Component {
  render() {
    return <DestinoListPageContainer {...this.props} />;
  }
}
